import React from 'react';
import { Typography } from 'antd';
import { aboutCopyEn } from '../../content/aboutCopy.en';
import styles from './About.module.css';

const { Title, Paragraph } = Typography;

const About: React.FC = () => {
  return (
    <div className={styles.about}>
      <div className={styles.container}>
        <section className={styles.section}>
          <Title className={styles.title}>{aboutCopyEn.title}</Title>
          <Paragraph className={styles.lead}>{aboutCopyEn.lead}</Paragraph>
        </section>

        {aboutCopyEn.sections.map((section) => (
          <section key={section.title} className={styles.section}>
            <Title level={2} className={styles.sectionTitle}>
              {section.title}
            </Title>
            {section.paragraphs.map((p) => (
              <Paragraph key={p} className={styles.text}>
                {p}
              </Paragraph>
            ))}
            {section.bullets && (
              <ul className={styles.list}>
                {section.bullets.map((b) => (
                  <li key={b} className={styles.listItem}>
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  );
};

export default About;
